import {StyleSheet, Dimensions} from 'react-native';
import {Colors} from '../../styles/Colors';
import ConstantStyles from '../../styles/ConstantStyles';
import {styles} from '../../theme';
const windowHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  container: {
    width: '100%',
    height: windowHeight,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: 'white',
    fontFamily: styles.font.IranYekan[400],
    fontSize: 16,
    textAlign: 'center',
    padding: 32,
    position: 'absolute',
    bottom: windowHeight / 2,
  },
  reloadButton: {
    backgroundColor: Colors.secondary,
    borderRadius: ConstantStyles.size.border_1,
    justifyContent: 'center',
    alignItems: 'center',
    height: ConstantStyles.size.button_2,
    marginTop: ConstantStyles.size.vertical_1,
    paddingHorizontal: 2 * ConstantStyles.size.horizontal_1,
  },
  reloadText: {
    color: 'white',
    fontFamily: styles.font.IranYekan[400],
    fontSize: 16,
    textAlign: 'center',
    marginTop: -3,
  },
});
